import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createHocName from '../../services/create-hoc-name';
import { ComponentsContext } from './components-context';

export default function withComponents(WrappedComponent) {
  const WithComponents = (props) => (
    <ComponentsContext.Consumer>
      {(components) => <WrappedComponent {...components} {...props} />}
    </ComponentsContext.Consumer>
  );

  WithComponents.displayName = createHocName(
    'WithComponents',
    WrappedComponent,
  );

  hoistNonReactStatics(WithComponents, WrappedComponent);

  return WithComponents;
}
